import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function GetLoyaltyRewards(websiteId, loginSuccess) {
  const {getLoyaltyRewards, loading, error} = useQuery({
    query: gql`
      query getLoyaltyRewardsSpoonity($websiteId: String) {
        getLoyaltyRewards(websiteId: $websiteId) {
          rewardsResume {
            available
            name
            description
            progressPercentage
          }
          tier {
            currentTier {
              name
              description
              progressPercentage
            }
            nextTier {
              name
              description
            }
          }
        }
      }
    `,
    variables: {websiteId},
    omit: !loginSuccess,
    fetchPolicy: 'network-only'
  })

  return {
    loyaltyRewardsList: getLoyaltyRewards?.rewardsResume,
    tierInformation: getLoyaltyRewards?.tier,
    loading,
    error
  }
}
